/*
* Left sidebar, using rsuite's sidenav
*/

import { Link } from 'react-router-dom';
import { Sidenav, Nav, Icon, Dropdown } from 'rsuite';
import * as _ from 'lodash';
import * as React from 'react';

import Auth from '../auth/auth';
import { NavigationLinks } from '../common/navigation';

// import default style
import 'rsuite/dist/styles/rsuite.min.css';
import './sidebar-navigation.css';

export class ComplexToggleComponent extends React.Component<any, any> {
    public constructor(props: any) {
        super(props);
    }

    public render() {        
        return (
            <div className="complex-toggle-component-wrapper">
                {this.props.children}
            </div>
        );
    }
}

export default class SidebarNavigation extends React.Component<any, any> {
    public readonly messagesPathPrefix: string = 'app.sidebar.';
    
    // constants
    public readonly NavKeys = {
        home: 'home',
        clients: 'clients',
        associations: 'associations',
        inventory: 'inventory',
        orders: 'orders',
        administration: 'administration'    
    };
    public readonly DefaultExpandedNavKeys: any = [
        this.NavKeys.home,
        this.NavKeys.clients,
        this.NavKeys.associations,
        this.NavKeys.inventory,
        this.NavKeys.orders,
        this.NavKeys.administration
    ];        
    public readonly DefaultNavItemIcons = {
        search: 'search',
        addNew: 'plus-square',
        order: 'tasks'
    };
    public readonly SidebarCollapsedCssClass = 'sidebar-collapsed';
    public readonly SidebarConfig = {
        LocalStorageTokens: {
            sidebarCollapsed: 'sidebarCollapsed',
        }
    };

    public constructor(props: any) {
        super(props);
        this.auth = new Auth();
        this.handleWindowFocus = this.handleWindowFocus.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleAuthProfileUpdated = this.handleAuthProfileUpdated.bind(this);
    }

    private auth: Auth;
    private sidebarMounted: boolean = false;
    private roleRefreshTimer: number | undefined;
    private lastRoleRefreshAt: number = 0;
    private roleRefreshInProgress: boolean = false;

    public handleWindowFocus() {
        this.scheduleRoleRefresh();
    }

    public handleVisibilityChange() {
        if (document.visibilityState === 'visible') {
            this.scheduleRoleRefresh();
        }
    }

    public handleAuthProfileUpdated() {
        this.forceUpdate();
    }

    public componentDidMount() {
        this.sidebarMounted = true;
        const isSidebarCollapsed = this.getSidebarCollapsedState();

        // console.log(`componentDidMount calling attachSidebarCollapsedStateCSSClass with isSidebarCollapsed ${isSidebarCollapsed}`);
        
        this.attachSidebarCollapsedStateCSSClass(isSidebarCollapsed);

        window.addEventListener('focus', this.handleWindowFocus);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('auth-profile-updated', this.handleAuthProfileUpdated);

        // Also refresh once on mount so newly-granted roles show immediately.
        this.refreshRoles();
    }

    public componentWillUnmount() {
        this.sidebarMounted = false;
        window.removeEventListener('focus', this.handleWindowFocus);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('auth-profile-updated', this.handleAuthProfileUpdated);
        if (this.roleRefreshTimer !== undefined) {
            window.clearTimeout(this.roleRefreshTimer);
        }
    }

     /* LocalStorage management functions */
  public clearAllLocalStorageValues() {
    // Clears/removes all known local storage values

    localStorage.removeItem(this.SidebarConfig.LocalStorageTokens.sidebarCollapsed);    
  }

  public getLocalStorageValue(token: string) {
    // Returns a local storage value by token name

    if (!token) { return null; }

    return localStorage.getItem(token);
  }

  public setLocalStorageValue(token: string, value: any) {
    // Store a value in local storage

    if (!token) { return; }

    localStorage.setItem(token, value);
  }

    public getSidebarCollapsedState() {
        const lsValue = this.getLocalStorageValue(this.SidebarConfig.LocalStorageTokens.sidebarCollapsed);

        const result = (lsValue === 'true') ? true : false;
        // const result = (_.get(this.props, 'branding.sidebarCollapsed', false)) ? true : false;

        // console.log(`sidebarCollapsedState lsValue ${lsValue} result ${result}`);

        return result;
    }

    public appText(messagePath: string, prependMessagesPathPrefix: boolean = true, tokenValue: string = ''): string {
        // Return branded app text, based on partial intl.messages path token suffix. Auto concat'ed with this.messagesPathPrefix
        let result = '';
        if (!messagePath || !this.messagesPathPrefix || !this.props.intl || !this.props.intl.messages) { return result; }
        const path = prependMessagesPathPrefix ? `${this.messagesPathPrefix}${messagePath}` : messagePath;

        result = _.get(this.props.intl.messages, path);

        if (result === undefined) {
            // console.log(`ERROR: app-component-base.t: Undefined message for token path "${path}".`);
            result = '';
        }

        const re = /{TOKEN_VALUE}/gi;
        result = result.replace(re, tokenValue);

        return result;
    }

    // Handlers
    public handleToggle() {
        const newSidebarCollapsed = !this.getSidebarCollapsedState();
        
        // console.log(`sidebar-navigation.handleToggle setting sidebarCollapsed to ${newSidebarCollapsed}`);   
        
        // this.props.dispatch(Actions.sidebarNavigationCollapsed(newSidebarCollapsed));
        this.setLocalStorageValue(this.SidebarConfig.LocalStorageTokens.sidebarCollapsed, newSidebarCollapsed);

        this.attachSidebarCollapsedStateCSSClass(newSidebarCollapsed);

        this.forceUpdate();
    }
    
    public handleSelect(ek: any, e: any) {       
        switch (ek) {
            case 'sidebar-collapse-toggle':
                this.handleToggle();
                break;
            default:
                // console.log(`handleSelect DEFAULT SWITCH ek ${ek} e`, e);
                break;
        }
    }

    public attachSidebarCollapsedStateCSSClass(isCollapsed: boolean = false) {
        // console.log(`attachSidebarCollapsedStateCSSClass isCollapsed ${isCollapsed}`);

        if (isCollapsed) {
            document.body.classList.add(this.SidebarCollapsedCssClass);                        
        } else {            
            document.body.classList.remove(this.SidebarCollapsedCssClass);
        }                    
    }

    // Renderers
    public render() {
        const auth = new Auth();
        const isAdmin = auth.isAdmin();
        const isClient = auth.isClient();
        const canAccessRegionalComponentLists = auth.canAccessRegionalComponentLists();
        const userObjId = auth.getSessionUserObjectId();
        
        const isCollapsed = this.getSidebarCollapsedState();
                            
        // Component factories/helpers
        const GetIcon = (name) => (<Icon icon={name} />);
        const BuildDropdown = ({ eventKey, titleAppTextPath, iconName, divider = true, hideCaret = true, children, ...props }) => {
            const placement = 'rightTop';

            return (
                <Dropdown
                    eventKey={eventKey}
                    placement={placement}
                    title={(
                        <span className="sidenav-dropdown-title">
                            {this.appText(titleAppTextPath)}
                        </span>
                    )}                  
                    toggleComponentClass={ComplexToggleComponent}                    
                    icon={GetIcon(iconName)}  
                    className="sidenav-dropdown-title-wrapper"  
                    noCaret={hideCaret}     
                    trigger="hover"                     
                >
                    {children}      
                    {(divider) ? (<Dropdown.Item divider={true} />) : (<div />)}                        
                </Dropdown>          
            );          
        };    

        const BuildDropdownItemNavLink = ({ eventKey, itemAppTextPath, iconName, linkTo, ...props }) => {
            const navLinkProps = {
                to: linkTo,  
            };

            return (
                <Dropdown.Item
                    eventKey={eventKey}
                    icon={GetIcon(iconName)}
                    componentClass={Link}
                    className="sidenav-dropdown-item-link"
                    {...navLinkProps}
                >
                    {this.appText(itemAppTextPath)}
                </Dropdown.Item>
            );            
        };        

        // sections
        const headerSection = (
            <div className="sidenav-header-wrapper">
                <div className="sidenav-button-burger" onClick={(e) => { this.handleToggle(); }}>
                    <Icon icon="bars" />
                </div>         
                {(!isCollapsed) ? (
                    <div className="sidenav-branding-logo-image-wrapper">
                        <img
                            src={this.props.branding.logo.nav}
                            alt={this.props.branding.companyName}
                            className="light-logo sidenav-branding-logo-image"                        
                        />
                    </div>
                ) : (<div />)
                }
            </div>
        );
        
        const homeSection = (
            <BuildDropdown eventKey={this.NavKeys.home} titleAppTextPath="links.home" iconName="home" divider={!isCollapsed}>                
                {(isClient) ? (
                    <BuildDropdownItemNavLink eventKey="communities-home-communities" itemAppTextPath="links.communities-home.communities" iconName="list-alt" linkTo={NavigationLinks.clientDashboardHome()} />
                ) : (
                    <div>
                        <BuildDropdownItemNavLink eventKey="home-active-jobs" itemAppTextPath="links.home.active-jobs" iconName="list-alt" linkTo={NavigationLinks.userDashboard()} />
                        <BuildDropdownItemNavLink eventKey="home-prepared-bids" itemAppTextPath="links.home.prepared-bids" iconName="list-alt" linkTo={NavigationLinks.userPreparedBids()} />
                    </div>
                )}
                <BuildDropdownItemNavLink eventKey="home-my-account" itemAppTextPath="links.home.my-account" iconName="profile" linkTo={NavigationLinks.myAccount(userObjId)} />
            </BuildDropdown>
        );

        const clientsSection = (!isClient) ? (
            <BuildDropdown eventKey={this.NavKeys.clients} titleAppTextPath="links.clients" iconName="building" divider={!isCollapsed}>
                <BuildDropdownItemNavLink eventKey="clients-search" itemAppTextPath="links.clients.search" iconName={this.DefaultNavItemIcons.search} linkTo={NavigationLinks.clientSearch()} />
                <BuildDropdownItemNavLink eventKey="clients-search-contacts" itemAppTextPath="links.clients.search-contacts" iconName={this.DefaultNavItemIcons.search} linkTo={NavigationLinks.clientSearchContacts()} />
                <BuildDropdownItemNavLink eventKey="clients-add-new" itemAppTextPath="links.clients.add-new" iconName={this.DefaultNavItemIcons.addNew} linkTo={NavigationLinks.clientAdd()} />
            </BuildDropdown>                        
        ) : (<div />);

        const associationsSection = (!isClient) ? (
            <BuildDropdown eventKey={this.NavKeys.associations} titleAppTextPath="links.associations" iconName="briefcase" divider={!isCollapsed}>
                <BuildDropdownItemNavLink eventKey="associations-search" itemAppTextPath="links.associations.search" iconName={this.DefaultNavItemIcons.search} linkTo={NavigationLinks.associationSearch()} />
                <BuildDropdownItemNavLink eventKey="associations-export-orders" itemAppTextPath="links.associations.export-association-orders" iconName={this.DefaultNavItemIcons.search} linkTo={NavigationLinks.associationExportOrders()} />
                <BuildDropdownItemNavLink eventKey="associations-add-new" itemAppTextPath="links.associations.add-new" iconName={this.DefaultNavItemIcons.addNew} linkTo={NavigationLinks.associationAdd()} />
            </BuildDropdown>
        ) : (<div />);

        const inventorySection = (!isClient) ? (
            <BuildDropdown eventKey={this.NavKeys.inventory} titleAppTextPath="links.inventory" iconName="cubes" divider={!isCollapsed}>
                <BuildDropdownItemNavLink eventKey="inventory-research-components" itemAppTextPath="links.inventory.research-components" iconName="creative" linkTo={NavigationLinks.researchComponentsSearch()} />
                {(canAccessRegionalComponentLists) ? (
                    <BuildDropdownItemNavLink eventKey="inventory-regional-component-lists" itemAppTextPath="links.regional-component-lists" iconName="list-alt" linkTo={NavigationLinks.regionalComponentListManager()} />
                ) : (<div />)}
            </BuildDropdown>                        
        ) : (<div />);

        const ordersSection = (!isClient) ? (
            <BuildDropdown eventKey={this.NavKeys.orders} titleAppTextPath="links.orders" iconName="handshake-o" divider={!isCollapsed && isAdmin}>                
                <BuildDropdownItemNavLink eventKey="orders-research-bids" itemAppTextPath="links.orders.research-bids" iconName={this.DefaultNavItemIcons.order} linkTo={NavigationLinks.researchBids()} />
                <BuildDropdownItemNavLink eventKey="orders-outstanding-bids" itemAppTextPath="links.orders.outstanding-bids" iconName={this.DefaultNavItemIcons.order} linkTo={NavigationLinks.outstandingBids()} />
                <BuildDropdownItemNavLink eventKey="orders-reminder-bids" itemAppTextPath="links.orders.reminder-bids" iconName={this.DefaultNavItemIcons.order} linkTo={NavigationLinks.reminderBids()} />
                <BuildDropdownItemNavLink eventKey="orders-send-bids" itemAppTextPath="links.orders.send-bids" iconName="share-square" linkTo={NavigationLinks.sendBids()} />
                <BuildDropdownItemNavLink eventKey="orders-won-jobs" itemAppTextPath="links.orders.won-jobs" iconName={this.DefaultNavItemIcons.order} linkTo={NavigationLinks.wonJobs()} />
                <BuildDropdownItemNavLink eventKey="orders-search" itemAppTextPath="links.orders.search" iconName={this.DefaultNavItemIcons.search} linkTo={NavigationLinks.orderSearch()} />
                <BuildDropdownItemNavLink eventKey="orders-add-new-bid" itemAppTextPath="links.orders.add-new-bid" iconName={this.DefaultNavItemIcons.addNew} linkTo={NavigationLinks.orderAddBid()} />
            </BuildDropdown>
        ) : (<div />);

        const administrationSection = (isAdmin) ? (
            <BuildDropdown eventKey={this.NavKeys.administration} titleAppTextPath="links.administration" iconName="wrench" divider={false}>
                <BuildDropdownItemNavLink eventKey="administration-users" itemAppTextPath="links.administration.users" iconName="peoples" linkTo={NavigationLinks.userSearch()} />
                <BuildDropdownItemNavLink eventKey="administration-add-user" itemAppTextPath="links.administration.add-user" iconName="user-plus" linkTo={NavigationLinks.userAdd()} />
                <BuildDropdownItemNavLink eventKey="administration-invite-client" itemAppTextPath="links.administration.invite-client" iconName="user-plus" linkTo={NavigationLinks.inviteAdd()} />
                <BuildDropdownItemNavLink eventKey="administration-coordinator-jobs" itemAppTextPath="links.administration.coordinator-jobs" iconName="tasks" linkTo={NavigationLinks.coordinatorJobsSearch()} />
                { /* <BuildDropdownItemNavLink eventKey="administration-default-managers" itemAppTextPath="links.administration.default-managers" iconName="peoples-map" linkTo={NavigationLinks.defaultManagers()} /> */ }
                <BuildDropdownItemNavLink eventKey="administration-manage-lookup-tables" itemAppTextPath="links.administration.manage-lookup-tables" iconName="database" linkTo={NavigationLinks.lookupTables()} />
                { /* <BuildDropdownItemNavLink eventKey="administration-query-db" itemAppTextPath="links.administration.query-database" iconName="database" linkTo={NavigationLinks.queryDatabase()} /> */ }
            </BuildDropdown>
        ) : (<div />);

        return (
            <div className="sidenav-wrapper">
                <Sidenav
                    appearance="subtle"
                    expanded={!isCollapsed}
                    // onSelect={(ek, e) => { this.handleSelect(ek, e); }}
                    defaultOpenKeys={this.DefaultExpandedNavKeys}
                >
                    <Sidenav.Header className="sidenav-header">
                        {headerSection}
                    </Sidenav.Header>
                    <Sidenav.Body>                       
                        <Nav>
                            {/* <SidebarNavClient /> */}
                            {homeSection}
                            {clientsSection}
                            {associationsSection}
                            {inventorySection}        
                            {ordersSection}
                            {administrationSection}                      
                        </Nav>                                                
                    </Sidenav.Body>
                </Sidenav>
            </div>
        );
    }

    private scheduleRoleRefresh() {
        if (this.roleRefreshTimer !== undefined) {
            window.clearTimeout(this.roleRefreshTimer);
        }
        const runRefresh = () => {
            this.roleRefreshTimer = undefined;
            this.refreshRoles();
        };
        this.roleRefreshTimer = window.setTimeout(runRefresh, 250);
    }

    private refreshRoles() {
        const now = Date.now();
        if (this.roleRefreshInProgress || now - this.lastRoleRefreshAt < 1000) {
            return;
        }

        this.lastRoleRefreshAt = now;
        this.roleRefreshInProgress = true;
        this.auth.refreshSessionRolesFromApi().then(() => {
            this.roleRefreshInProgress = false;
            if (this.sidebarMounted) {
                this.forceUpdate();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/applayout/sidebar-navigation.tsx